import React from "react";
import menu from "../Resources/svg/menu.svg";
import closeMenu from "../Resources/svg/close-button.svg";

 const IconLogoutRespons = ({ openPanel, closePanel, active } )=> {

    return (
        <div className="iconLogoutRespons">
          {!active ? (
            <img
              src={menu}
              alt="menu"
              className="iconLogoutRespons__icon-menu"
              onClick={() => openPanel()}
            />
          ) : (
            <img
              src={closeMenu}
              alt="closeMenu"
              className="iconLogoutRespons__icon-menu"
              onClick={() => closePanel()}
            />
          )}
        </div>
    );
  }
export default IconLogoutRespons;
